const ja = {
  options: {
    pendingAppeal: "未処理",
    waiting: "銀行の返答待ち",
    closed: "処理完了",
    searchID: "ウェブサイトの注文番号を検索",
    originID: "サイト注文番号",
    omniOriginID: "販売者の注文番号",
    website: "対象Webサイト",
    omniWebsite: "ソース",
    chargebackStatus: "チャージバック状況",
    chargebackType: "タイプ",
    all: "全て",
    retrieval: "調整",
    Chargeback1st: "初回チャージバック",
    Chargeback2nd: "2回目のチャージバック",
    prearbitration: "事前仲裁",
    reason: "チャージバックの理由",
    allReason: "全チャージバック理由",
    notdescribed: "商品相違",
    notReceived: "商品未着",
    fraud: "不正利用",
    others: "その他",
    download: "現在の結果をエクスポートする",
    originalOrderIDWebsite: "サイト注文番号 / Webサイト",
    omniOriginalOrderIDWebsite: "販売者の注文番号/店舗/ウェブサイト",
    updateTime: "ステータス更新日時",
    deadline: "処理期限",
    lessthandays: "3日以内",
    retrievalChargebackAmount: "チャージバック金額",
    operation: "操作",
    details: "詳細",
    total: "一般",
    nocases: "現在、未処理のチャージバック申請はありません。",
    noResult: "該当する注文の注文転送および拒否情報が見つかりませんでした。",
    appealResults: "異議申立結果",
    time: "期間",
    currentStatus: "ステータス",
    exportResults: "現在の結果をエクスポートする",
    allwebsite: "すべてのサイト",
    omniAllwebsite: "すべてのウェブサイト/ストア",
    allstatus: "すべてのステータス",
    allResult: "全結果",
    chargebackTime: "チャージバック日時",
    closeDate: "クローズ日時",
    status: "ステータス",
    startTime: "開始日",
    endTime: "終了日",
    to: "に",
    storeGroup: "Webサイト / グループ",
    omniStoreGroup: "店舗/ウェブサイト/グループ",
    groupName: "グループ",
    allGroup: "全グループ",
    operatorName: "担当者",
    chargebackId: "チャージバック番号",
    placeHolder: "検索条件を入力",
    chargebackIdo: "注文番号",
    chargebackProtect: "チャージバック保護"
  },
  chargeBackDetail: {
    pendingAppealList: "保留リスト",
    retrievalDetail: "調整",
    chargebackDetail: "チャージバック",
    retrievalDate: "注文日",
    creationTime: "作成日時",
    retrievalAmount: "調整量",
    cardAssociation: "カードブランド",
    comment: "備考",
    file: "書類",
    reason: "理由",
    originalTransactionInformation: "元の注文情報",
    websiteURL: "WebサイトURL",
    originalOrderID: "元の販売者注文番号",
    transactionID: "取引番号",
    itemName: "配送情報",
    amount: "取引金額",
    transactionTime: "元のトランザクション時間",
    shippingName: "荷受人名",
    clientEmail: "ユーザーのメールアドレス",
    shippingPhoneNumber: "荷受人の連絡先番号",
    order: "一連の出来事",
    reorder: "イベントの順序を逆にする",
    retrievalProcess: "調整工程",
    chargebackProcess: "チャージバックプロセス",
    bankNotify: "銀行調整通知書が作成され、調整額が決定されます。",
    bankNotify2nd: "あなたは異議申し立てを提出し、銀行の返答を待っています",
    bankNotify4nd: "チャージバックの申し立てを送信し、銀行の応答を待っています",
    bankNotify3rd: "申し立て情報は最適化される可能性があります。再送信してください。",
    waivedCase: "あなたは異議申し立てを放棄し、銀行の返答を待っています",
    expiredCase: "異議申し立ての期限が切れたため、あなたは異議申し立てを放棄し、銀行の返答を待っています。",
    bankNotify4th: "銀行の最初のチャージバック通知が作成され、チャージバック金額は",
    bankNotifyretrieval: "銀行のチャージバック通知が作成され、注文金額が",
    failedRetrievalCase: "注文に対する異議申し立てが失敗しました",
    highText: "控訴が成功する確率は高いです。控訴することを強くお勧めします。ページの指示に従って、可能な限り資料を完成させてください。",
    midText: "控訴が成功する確率は平均的です。控訴することをお勧めします。ページの指示に従って、可能な限り資料を完成させてください。",
    lowText: "控訴が成功する確率は低いです。アピールしてみてもいいでしょう。ページの指示に従って、できる限り資料を完成させてください。",
    statement: "異議申し立ての成功確率の表示は、異議申し立て/チャージバックの結果の推定値にすぎず、実際の結果を保証するものではありません。ご質問がございましたら、PingPong Checkout までお問い合わせください。",
    statusLabel: "勝率評価",
    cardHolderCancelled: "カード所有者が申請を取り下げ、異議申し立てが成功する",
    chargeback2nd: "銀行は 2 回目のチャージバック通知を発行します",
    cardHolderConfirmed: "カード所有者は事前仲裁を確認しました。返信してください",
    confirmedArbitration: "事前仲裁を確認し、銀行の応答を待っています",
    arbitrationFailed: "銀行仲裁結果：控訴棄却",
    noneedArbitration: "この取引は返金されました。異議申し立ては必要ありません",
    bankFeedbackSuccess: "銀行フィードバックの結果: 異議申し立ては成功しました",
    bankFeedbackFailed: "銀行仲裁結果：控訴棄却",
    bankFeedbackPending: "あなたは仲裁段階に入り、銀行の応答を待っています。",
    waive: "控訴を諦める",
    appealNow: "アピールしたい",
    editMaterial: "苦情資料の修正",
    respondRetrieval: "銀行注文調整通知を受け取りました。ご返信ください。",
    respondedRetrieval: "銀行の注文調整通知に返信しました。銀行から結果が返されるまで気長にお待ちください。",
    issuesInfo: "あなたの情報には次の問題があります。修正して再送信してください。",
    waivedIssues: "異議申し立ては諦めました。銀行から結果が返されるまで辛抱強く待ってください。",
    expiredWaive: "期限内に異議を申し立てられない場合は、放棄したものとみなします。銀行から結果が返されるまで気長にお待ちください。",
    chargebackCase1st: "買収銀行の最初の拒否通知に応答してください",
    respond1stChargeback: "あなたは銀行の最初のチャージバック通知に返信しました。銀行から結果が返されるまで気長にお待ちください。",
    chargebackCase2nd: "取得銀行からの 2 回目のチャージバック通知。ご返信ください。",
    respond2ndChargeback: "あなたは銀行の 2 回目のチャージバック通知に返信しました。銀行から結果が返されるまで気長にお待ちください。",
    resondCardHolderConfirmed: "カード所有者は事前仲裁を確認しました。返信してください",
    lessThen3days: "3日以内",
    lessThen3daysFont: "お願いします",
    lessThen3daysAffect: "期限までに返信してください。期限切れは上訴を放棄したものとみなされます。",
    lessThen3daysEnd: "仲裁が不成立となった場合、仲裁手数料は当事者が負担するものとします。",
    comfirmedArbitration: "事前仲裁を確認しました。銀行から結果が返されるまで気長にお待ちください。",
    failedArbitration: "銀行仲裁の結果は、チャージバックは有効で、異議申し立ては失敗しました。",
    arbitrationSuccess: "銀行仲裁の結果は次のとおりです: 控訴は成功しました",
    cancelChargeback: "カード所有者がチャージバック要求を取り下げる",
    noneedAppeal: "この取引は返金されました。異議申し立ては必要ありません",
    bankArbitrationSuccess: "銀行のフィードバック結果は次のとおりです: 異議申し立ては成功しました",
    bankArbitrationPartialSuccess: "銀行のフィードバック結果は次のとおりです: 部分的に成功",
    bankArbitrationFailed: "銀行からのフィードバック結果は次のとおりです: 申し立ては失敗しました",
    cancel: "キャンセル",
    confirmedPreArbitration: "事前仲裁を確認する",
    confirm: "確認する",
    date: "日付",
    amountT: "金額",
    noEmoji: "絵文字は入力しないでください",
    chargebackProtect: "チャージバック保護が進行中です"
  },
  form: {
    retrievalAppeal: "注文に対する異議申し立て",
    chargebackAppeal: "チャージバックに対する異議申し立て",
    uploadTips: "画像のアップロード要件: 必ずご確認ください",
    uploadTips2nd: "アップロードされた情報画像のテキストがはっきりと見える",
    uploadTips3rd: "最大サイズは 5M を超えることはできず、形式は JPG、JPEG、PNG、および BMP に制限されます。",
    transactionInformation: "取引情報",
    itemName: "商品名",
    receiverName: "荷受人名",
    receiverPhone: "荷受人の電話番号",
    ShippingAddress: "お届け先の住所",
    transactionInformationScreenshot: "ストアのバックエンド トランザクション情報のスクリーンショット",
    addapic: "画像を追加",
    shippingInformation: "配送情報",
    shippingCompany: "運送会社",
    trackingNumber: "物流注文番号",
    thewaybillInformationScreenshot: "運送状情報のスクリーンショット",
    imagesOfMerchandise: "製品写真",
    DescriptionGoods: "製品の写真と詳細な説明",
    Imageofdelivered: "実際の商品写真を発送",
    cardholdersSigned: "紛争が取り消されたことをカード所有者が提供した証拠がある場合は、提出してください。",
    customerContactInformation: "販売者とユーザーの間の通信記録を提供するようにしてください。",
    ReasonsAppeal: "販売者が苦情に反論する理由とポイント",
    reasonsAndPoints: "その理由とポイント",
    feedbacksOfgoods: "この商品は過去に購入者から高い評価を得ています。その場合はご提供ください。",
    proofOfdelivery: "配達証明。領収書の写真または署名がある場合は、それも一緒に提出してください。",
    cancellationAndRefundPolicy: "販売者のキャンセル/返品および返金ポリシー",
    transportationPolicy: "販売者の配送ポリシー",
    submit: "提出する",
    save: "一時的に保存して後で送信する",
    submitTips: "少なくとも 1 つの情報を入力してください",
    submitSuccess: "送信成功",
    saveSuccess: "一時保存に成功しました",
    forgo: "あなたは控訴を断念しました",
    netError: "ネットワークが混雑しています。後でもう一度お試しください。",
    select: 'Please select',
    waiveAppeal: "異議申し立てを放棄してもよろしいですか?一度諦めてしまうと再度異議を申し立てることはできませんので、慎重に判断してください。",
    chargebackConfirm: "支払いを拒否した場合は仲裁段階に入り、その結果生じる仲裁手数料 500 米ドルは仲裁に負けた当事者が負担することになります。本気ですか？",
    waitAmins: "支払いリクエストが開始されました。元の支払いページで支払いを続行するか、15 分待ってから再度支払いを行ってください。",
    noticeSuccessConfirm: "事前仲裁を正常に確認しました",
    noticeFaildAppeal: "あなたは控訴を断念しました",
    orderClipboard: "注文番号がクリップボードにコピーされました",
    noticeCopyFailed: "コピーに失敗しました。もう一度お試しください",
    noData: "現在、銀行からのフィードバックを待っている注文転送およびチャージバックのアプリケーションはありません。",
    noData2nd: "現在、注文調整および支払い拒否の受付が終了した申請はありません。",
    uploadFailed: "ファイルのアップロードに失敗しました。もう一度アップロードしてください",
    imageLimited: "最大 {max} 枚の写真をアップロードできます",
    uoloadLimited: "アップロードされるファイルは {max}M を超えることはできません。"
  }
};
export default ja;
